module.exports = __webpack_public_path__ + "static/img/2.313c101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/2.png
// module id = /7Cm
// module chunks = 4